import { selectUserId } from "@web-src/modules/auth/store/authSlice";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch } from "react-router-dom";
import {
  selectActiveChatId,
  setActiveChatId,
} from "@web-src/modules/chats/store/chatsSlice";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { useConversations } from "./useConversations";

export const useActiveChat = () => {
  const dispatch = useDispatch();
  const match = useMatch(`/:entityId/chats/:activeChatId`);
  const { navigateToPage } = useNavigation();
  const activeChatId = useSelector(selectActiveChatId);
  const { conversations } = useConversations();
  const chatId = activeChatId || match?.params.activeChatId;
  const chat = useMemo(
    () =>
      chatId ? conversations?.find((item) => item.id === chatId) : undefined,
    [chatId, conversations]
  );
  const meId = useSelector(selectUserId);
  const isParticipant = useMemo(() => {
    if (
      chat?.data?.type === "chat" ||
      chat?.data.type === "entity_conversation"
    ) {
      return undefined;
    }
    return !!chat?.data?.users?.find((userId) => userId === meId);
  }, [meId, chat]);

  return {
    chat: chat?.data,
    isParticipant,
    setActiveChat: (id: string, navigate = true) => {
      if (navigate) {
        navigateToPage(
          "chatsActiveChat",
          { activeChatId: id },
          { replacePathOnly: true }
        );
      }
      dispatch(setActiveChatId(id));
    },
  };
};
